<template>
  <b-modal
      data-test-path="dialog-multi-select"
      id="bv-modal-multiselect"
      ref="modal"
      @ok="onOk"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <Multiselect class="pt-1 pb-1 col-10"
                       :items="multiSelectItems"
                       v-model="multiselectSelected"
                       @item-removed="updVals"
                       :allow-add="true">
          </Multiselect>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import Multiselect from "@/components/inputs/controls/Multiselect";

  export default {
    name: "MultiSelectDialog",
    components: {Multiselect},
    methods: {
      async onOk(ev){
        if(this.resolve != null){
          this.resolve(this.multiselectSelected);
          this.resolve = null;
        }
        this.$refs.modal.hide();
      },
      async onHide(ev){
        if(this.resolve != null){
          this.resolve(false);
          this.resolve = null;
        }
        this.$refs.modal.hide();

      },
      reset(){
        this.resolve = null;
      },
      updVals(item) {
        this.multiselectSelected =
            typeof item === 'string' || item instanceof String ?
                this.multiselectSelected = this.multiselectSelected.filter(x => x !== item) :
                this.multiselectSelected = this.multiselectSelected.filter(x => x.value !== item.value);
      }
    },
    data: () => ({
      title:"title",
      resolve: null,
      multiSelectItems: [],
      multiselectSelected: [],
    })
  }
</script>